import FormikTextField from "../../../components/Common/FormikTextField";
import { Field } from "formik";
import React from "react";
import { useTranslation } from "react-i18next";
import { useCheckout } from "../../providers/CheckoutProvider";
import { AutomaticAddressLookup } from "./AutomaticAddressLookup";

export default (props) => {
  const { t } = useTranslation();
  const { options } = useCheckout();

  if (options.useAddressAutocompleteService) {
    return (
      <Field
        id="shipping-form-address"
        component={AutomaticAddressLookup}
        label={t("Address")}
        name="address"
      />
    );
  }

  return (
    <Field
      id="shipping-form-address"
      component={FormikTextField}
      label={t("Address")}
      name="address"
    />
  );
};
